import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Action } from 'src/app/_model/action-enum';
import { OotsRequest } from 'src/app/_model/oots-request';
import { BreadcrumbService } from 'src/app/_service/breadcrumb.service';
import { JwtUtilsService } from 'src/app/_service/jwt-utils.service';
import { ModalDialogService } from 'src/app/_service/modal-dialog.service';
import { StateService } from 'src/app/_service/state.service';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { OotsService } from 'src/app/_service/oots.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnDestroy {

  private eventsSubscription = new Subscription();
  step: number;
  ootsRequest: OotsRequest;
  isOotsPreview: boolean;

  constructor(
    private router: Router,
    private stateService: StateService,
    private breadcrumbService: BreadcrumbService,
    private jwtUtilService: JwtUtilsService,
    private dialogService: ModalDialogService,
    private translate: TranslateService, 
    private ootsService: OotsService
  ) {
    this.eventsSubscription.add(this.breadcrumbService.getStep.subscribe(step => this.step = step));
    this.eventsSubscription.add(this.stateService.ootsRequestObserver.subscribe(ootsRequest => this.ootsRequest = ootsRequest));
    this.eventsSubscription.add(this.stateService.ootsPreviewObserver.subscribe(isOotsPreview => this.isOotsPreview = isOotsPreview));
  }

  showTimer() { return this.isHeaderVisible(); }
  showBreadcrum() { return this.isHeaderVisible(); }
  showTimerAndButtons() { return this.isUserLogged() && this.isHeaderVisible(); }

  save() {
    this.stateService.action = Action.SAVE;
  }

  cancel() {
    this.stateService.action = Action.CANCEL;
  }

  oostRequestActive() {
    return this.stateService.ootsRequest != null && this.stateService.ootsRequest.uuid != null;
  }
  
  isHeaderVisible() {
    if (this.router.url.includes('/sede')
      || this.router.url.includes('/registry')) return false;
    return true;
  }

  isUserLogged() {
    return this.jwtUtilService.isLogged();
  }

  ngOnDestroy(): void {
    this.eventsSubscription.unsubscribe();
  }

  initializeComponent(step: number) {

    const data = {
          title: this.translate.instant('LOCATE.STEP_BACK_CONFIRMATION_MODAL'),
          message: this.translate.instant('LOCATE.STEP_BACK_CONFIRMATION_MODAL_DESC'),
          type: 'step-back-confirmation'
        };
        this.dialogService.openDialog(ModalDialogComponent, data)
          .subscribe(result => {
            if (result?.action === 'accept') {

              this.ootsService.resetOOTSRequest(this.ootsRequest.uuid).subscribe(
                    {
                      next: () => {
                        this.jwtUtilService.saveRedirect('true');
                        this.stateService.ootsRequestModelChanged(this.ootsRequest.uuid);
                        this.breadcrumbService.setStep(step);
                      },
                      error: (e) => {
                        console.error(e);
                      }
                    });
            }
          });
  }
}
